import React from 'react';
import { Switch, Redirect, withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import CeeSubjectSearchComponent from './cee/ceeSubjectSearchComponent';
import CeeResultsComponent from './cee/ceeResultsComponent';
import PrivateRoute from '../privateRoute';
import { switchPerm } from '../../store/ceeSearchStore';

import '../../css/search/search.scss';

class CeeSearchComponent extends React.Component {

    subjectSubpath = 'subject';
    resultsSubpath = 'results';

    render() {
        return (
            <div className="content-root content-root-wide">
                <Switch>
                    <PrivateRoute path={`${this.props.match.url}/${this.subjectSubpath}`} permission={switchPerm(this.props.registry, "SearchCEE", "SearchCRE", "AMLSearch", "SearchRPVE")} component={CeeSubjectSearchComponent} componentProps={this.props} />
                    <PrivateRoute path={`${this.props.match.url}/${this.resultsSubpath}`} permission={switchPerm(this.props.registry, "CEEReport", "CREReport", "AMLSearch", "SearchRPVE")} component={CeeResultsComponent} componentProps={this.props} />
                </Switch>
                {this.props.match.url === this.props.location.pathname &&
                    <Redirect to={{ pathname: `${this.props.match.url}/${this.subjectSubpath}`, state: this.props.location.state }} />}
            </div>
        );
    }
}

export default withRouter(withLocalize(CeeSearchComponent));